import { render, staticRenderFns } from "./CmsContent.vue?vue&type=template&id=590c698b&scoped=true"
import script from "./CmsContent.vue?vue&type=script&lang=ts"
export * from "./CmsContent.vue?vue&type=script&lang=ts"
import style0 from "./CmsContent.vue?vue&type=style&index=0&id=590c698b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "590c698b",
  null
  
)

export default component.exports